











































































































import { Component, Vue } from 'vue-property-decorator'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import { CompanySummaryReport, RecentReport } from '@/utils/Interfaces'
import {
  getCompanySummaryReport,
  postSummaryReportExcel,
  downloadSummaryReportExcel,
  getRecentSummaryReports,
} from '@/utils/ApiServices'
import TongHopDtLnTlCtTaoBaoCao from './TongHopDtLnTlCtTaoBaoCao.vue'
import TongHopDtLnTlCtBaoCaoGanDay from './TongHopDtLnTlCtBaoCaoGanDay.vue'
import TongHopDtLnTlCtDuLieuBaoCao from './TongHopDtLnTlCtDuLieuBaoCao.vue'
import { handle } from '@/utils/ErrorHandling'
import { AxiosResponse } from 'axios'
import fileDownload from 'js-file-download'

@Component({
  components: {
    BreadCrumbs,
    SectionTitle,
    TongHopDtLnTlCtTaoBaoCao,
    TongHopDtLnTlCtBaoCaoGanDay,
    TongHopDtLnTlCtDuLieuBaoCao,
  }
})
export default class TongHopDtLnTlCt extends Vue {
  breadcrumbs = [
    {
      text: 'Trang chủ',
      to: { name: 'Home' },
    },
    {
      text: 'Tổng hợp DT, LN, TL, CT',
      to: { name: 'TongHopDtLnTlCt' },
    },
  ]
  companies = []
  searchText = ''
  recentReports = []

  loading = false
  showRecentReports = true
  showReportCreate = true
  showReportData = true

  // ======================================================================

  fetchingReports = true
  companySummaryReports: Array<CompanySummaryReport> = []

  fetchingRecentReports = false
  recentReportExcels: Array<RecentReport> = []

  mounted () {
    this.updateReportData()
    this.updateRecentReports()
  }

  updateReportData () {
    this.fetchingReports = true
    getCompanySummaryReport(this.year)
      .then(response => {
        this.companySummaryReports = response.data
      })
      .catch(handle)
      .finally(() => {
        this.fetchingReports = false
      })
  }

  updateRecentReports () {
    this.fetchingRecentReports = true
    getRecentSummaryReports()
      .then(response => {
        this.recentReportExcels = response.data
      })
      .catch(handle)
      .finally(() => {
        this.fetchingRecentReports = false
      })
  }

  // ======================================================================

  year = (new Date).getFullYear() - 1  // Lấy 1 năm trước so với năm hiện tại
  reportTypes = ['BẢNG TỔNG HỢP']

  downloading = false

  async download () {
    if (this.downloading) return
    this.downloading = true

    const response = await postSummaryReportExcel(this.year).catch(error => {
      this.downloading = false
      handle(error)
    }) as AxiosResponse
    const id = response.data.id

    downloadSummaryReportExcel(id)
      .then(response => {
        const filename = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim()
        fileDownload(response.data, filename)
        this.updateRecentReports()
      })
      .catch(handle)
      .finally(() => {
        this.downloading = false
      })
  }
}
